import { useState, useEffect } from "react";
// import Head from "./Head";

import Navbar from "./Navbar";
import "./Header.css";

const Header = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 100) {
        setShow(true);
      } else {
        setShow(false);
      }
    });
  }, []);

  return (
    <div>
      {/* <Head /> */}
      <div className={`header ${show ? "header_white" : ""}`}>
        <Navbar />
      </div>
    </div>
  );
};

export default Header;
